/**
 * Route prefetch map — maps path prefixes to their lazy-loaded chunk loaders.
 * When a user hovers a sidebar link, we trigger the import() to start
 * downloading the chunk before they click.
 *
 * Each loader is only called once — subsequent calls return the cached promise.
 */

const prefetchCache = new Set<string>();

const routeLoaders: Record<string, () => Promise<unknown>> = {
  '/inventory': () => import('@/modules/inventory/pages/dashboard/InventoryDashboardPage'),
  '/crm': () => import('@/modules/crm/pages/dashboard/CrmDashboardPage'),
  '/crm/activity': () => import('@/modules/crm/pages/activity/ActivityPage'),
  '/service/work-orders': () => import('@/modules/service/pages/work-orders/WorkOrdersListPage'),
  '/service/subcontractors': () => import('@/modules/service/pages/subcontractors/SubcontractorsPage'),
  '/service/finance-sync': () => import('@/modules/service/pages/finance-sync/FinanceSyncPage'),
  '/finance': () => import('@/modules/finance/pages/FinanceDashboardPage'),
  '/settings/dealership': () => import('@/modules/tenant/pages/settings/DealershipSettingsPage'),
  '/settings/templates': () => import('@/modules/tenant/pages/settings/TemplateListPage'),
  '/settings/roles': () => import('@/modules/tenant/pages/roles/RolesPage'),
  '/employees': () => import('@/modules/tenant/pages/employees/EmployeesListPage'),
};

/**
 * Call this on mouseEnter / focus of a navigation link.
 * Finds the best-matching route loader and triggers the chunk download.
 */
export function prefetchRoute(path: string) {
  if (prefetchCache.has(path)) return;

  // Find the longest matching prefix
  const match = Object.keys(routeLoaders)
    .filter((prefix) => path.startsWith(prefix))
    .sort((a, b) => b.length - a.length)[0];

  if (match) {
    prefetchCache.add(path);
    routeLoaders[match]();
  }
}
